'use client';

import { useTranslations } from 'use-intl';

import { ProjectMessage } from '..';

function ProjectExpired({
  showHomePageButton,
  showPoweredBy,
  className,
  isWidget,
}: {
  showHomePageButton?: boolean;
  showPoweredBy?: boolean;
  className?: string;
  isWidget?: boolean;
}) {
  const t = useTranslations('Errors');
  const tUsability = useTranslations('Usability');

  return (
    <ProjectMessage
      title={t('expiredTitle')}
      description={t('expiredBody')}
      homeButtonLabel={t('backToHomepage')}
      imageAlt={tUsability('surveyExpiredAlt')}
      showHomePageButton={showHomePageButton}
      showPoweredBy={showPoweredBy}
      className={className}
      isWidget={isWidget}
    />
  );
}

export default ProjectExpired;
